module.exports = new __parcel__URL__("HTML.bf6adb3d.svg").toString();